import React from "react";

/** Four-point sparkle/star. Uses currentColor so it adapts to light/dark. */
export const Sparkle = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>
    <path d="M12 0c.9 6.4 4.7 10.2 11 11-6.3.9-10.1 4.7-11 11-.9-6.3-4.7-10.1-11-11C7.3 10.2 11.1 6.4 12 0Z" />
  </svg>
);

/** Decorative postage-stamp motif (blue, perforated edge, little planet). */
export const PostageStamp = ({ className = "" }) => (
  <div aria-hidden="true" className={className}>
    <div className="border-2 border-[color:var(--coh-ink)] bg-[color:var(--coh-blue)] p-1.5 shadow-nb-sm">
      <div className="flex h-14 w-14 items-center justify-center border-2 border-dashed border-white/70 text-white">
        <svg viewBox="0 0 48 48" className="h-8 w-8" fill="none" stroke="currentColor" strokeWidth="2.5">
          <circle cx="24" cy="23" r="9" fill="currentColor" stroke="none" />
          <ellipse cx="24" cy="24" rx="20" ry="6" transform="rotate(-20 24 24)" />
        </svg>
      </div>
    </div>
  </div>
);

/**
 * Purely decorative hero backdrop: orbit lines, royal-blue blobs, and sparkles.
 * Entirely aria-hidden and non-interactive; static (no motion) for reduced-motion safety.
 */
export const HeroDecor = () => (
  <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
    {/* Orbit lines */}
    <svg
      className="absolute inset-0 h-full w-full"
      viewBox="0 0 1200 620"
      preserveAspectRatio="xMidYMid slice"
      fill="none"
    >
      <ellipse cx="300" cy="300" rx="265" ry="215" stroke="var(--coh-ink)" strokeWidth="1.5" strokeDasharray="5 9" opacity="0.22" />
      <circle cx="930" cy="300" r="250" stroke="var(--coh-ink)" strokeWidth="1.5" strokeDasharray="5 9" opacity="0.18" />
      <circle cx="302" cy="300" r="7" fill="var(--coh-blue)" />
      <circle cx="930" cy="548" r="7" fill="var(--coh-blue)" />
      <circle cx="1035" cy="150" r="5" fill="var(--coh-blue)" />
      <circle cx="40" cy="330" r="5" fill="var(--coh-blue)" />
    </svg>

    {/* Royal-blue blobs peeking from the corners */}
    <div className="absolute -left-24 -top-20 h-72 w-72 bg-[color:var(--coh-blue)] opacity-90 rounded-[46%_54%_57%_43%/46%_43%_57%_54%]" />
    <div className="absolute -right-28 -bottom-24 h-80 w-80 bg-[color:var(--coh-blue)] opacity-90 rounded-[54%_46%_40%_60%/52%_52%_48%_48%]" />

    {/* Sparkles */}
    <Sparkle className="absolute top-8 right-10 h-6 w-6 text-[color:var(--coh-ink)]" />
    <Sparkle className="absolute bottom-12 left-6 h-5 w-5 text-[color:var(--coh-ink)]" />
  </div>
);
